import { render, staticRenderFns } from "./acreditacion-evaluacion.vue?vue&type=template&id=0d7adaf6&"
import script from "./acreditacion-evaluacion.component.ts?vue&type=script&lang=ts&"
export * from "./acreditacion-evaluacion.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports